import {removeUndefined} from "../../util/util";
import {
  WellAllocationDetailsValidator,
  type WellAllocationDetails,
  type WellAllocationRequest,
} from "../../model/well-allocation";
import {validateJSONNow} from "../../web/validation";
import {otsBaseApi} from "../ots-api";

export const wellAllocationApi = otsBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getWellAllocationDetails: builder.query<WellAllocationDetails, WellAllocationRequest>({
      query: (params) => ({
        url: "/production-volumes/containers/details",
        method: "GET",
        params: removeUndefined(params),
      }),
      transformResponse: (response: unknown) => validateJSONNow(WellAllocationDetailsValidator, response),
    }),
  }),
});

export const {useGetWellAllocationDetailsQuery} = wellAllocationApi;
